import { createStore, applyMiddleware, compose } from 'redux';
import createSentryMiddleware from 'redux-sentry-middleware';
import thunkMiddleware from 'redux-thunk';
import promise from 'redux-promise';

import resetTimeOnSetActiveDay from './app/middlewares/resetTimeOnSetActiveDay';
import debounceSetActiveDay from './app/middlewares/debounceSetActiveDay';
import populateReservationFromAppointment from './app/middlewares/populateReservationFromAppointment';
import rootReducer from './reducer';
import sentry from './app/utils/sentry';

let composeEnhancers;
const middlewares = [
  debounceSetActiveDay,
  resetTimeOnSetActiveDay,
  populateReservationFromAppointment,
  thunkMiddleware,
  promise,
];

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-underscore-dangle
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
  if (window.Sentry) {
    const sentryMiddleware = createSentryMiddleware(sentry());
    middlewares.push(sentryMiddleware);
  }

  composeEnhancers = compose;
}

export default function configureStore(preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        ...middlewares
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/store.js